import React, { useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { formatDate } from '../../utils/utils';
import AuditPopover from '../widgets/Popover';
import { useSelector } from 'react-redux';

const formatAuditValue = (value) => {
  const [expanded, setExpanded] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const constants = useSelector(state => state.constants.data);

  const handleExpand = (event) => {
    setAnchor(event.currentTarget);
    setExpanded(!expanded);
  }
  if(value?.details) {
    return (
      <Box>
        <Typography onClick={handleExpand} sx={{color: 'green', fontWeight: 'bold', cursor: 'pointer'}}>Click to see more</Typography>
        {anchor && expanded && <AuditPopover open={expanded} anchor={anchor} setAnchor={setAnchor}>
          <ul>
            <li>Assigned Patrol: {value.details.AssignedPatrol || 'N/A'}</li>
            <li>Task Type: {constants.taskTypes.find(t => t.id == value.details.TypeId).name}</li>
            <li>Customer Name: {value.details.CustomerName}</li>
            <li>Membership Information: {value.details.MembershipInfo}</li>
            <li>Customer Phone Number: {value.details.ContactPhoneNumber}</li>
            <li>Customer Address: {value.details.CustomerAddress}</li>
            <li>Customer Postcode: {value.details.CustomerPostcode}</li>
            <li>Case ID: {value.details.CaseId || value.details.Id}</li>
            <li>Location: {value.details.LocationLatitude + ', ' + value.details.LocationLongitude}</li>
            <li>Breakdown Address: {value.details.LocationDescription}</li>
            <li>Fault Type: {constants.faultType.find(t => t.id == value.details.FaultId).code}</li>
            <li>Reg #: {value.details.VehicleRegistrationNumber}</li>
            <li>Vehicle Brand: {constants.vehicleMakes.find(t => t.id == value.details.VehicleMakeId).name}</li>
            <li>Vehicle Model: {constants.vehicleModels.find(t => t.id == value.details.VehicleModelId).code}</li>
            <li>Vehicle Colour: {value.details.VehicleColour}</li>
            <li>Homestart: {value.details.IsHomestart ? 'Yes' : 'No'}</li>
            <li>Priority: {value.details.IsPriority ? 'Yes' : 'No'}</li>
            <li>Req. Itervention: {value.details.RequiresIntervention ? 'Yes' : 'No'}</li>
            <li>Comments: {value.details.Comments}</li>

          </ul>
        </AuditPopover>}
      </Box>
    );
  } else {
    return <Tooltip title={value}>{value}</Tooltip>;
  }
}

export const getAuditColumns = () => [
  { field: "id", headerName: "Audit ID", flex: 1, minWidth: 120 },
  { field: "actionType", headerName: "Action Tpe", flex: 1, minWidth: 120 },
  {
    field: "changedAt",
    headerName: "Event Time",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => formatDate(params.value, true),
  },
  {
    field: "oldValue",
    headerName: "Old Value",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <Tooltip title={params.value}>{params.value}</Tooltip>
    
  },
  {
    field: "newValue",
    headerName: "New Value",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => formatAuditValue(params.value)
  },
  {
    field: "changedBy",
    headerName: "User",
    flex: 0.5,
    minWidth: 120,
  },
];
